<template>
    <v-main class="justify-center" style="height: 100%; width: 100%; position: absolute;">
        <CardNav />
        <v-container>
            <v-row>
                <v-card elevation="12"
                    style="height: calc(100svh - 13.4svh - 2svw - 2svw - 2svw - 2svw - 22.66svh); width: calc(100svw - 2svw - 2svw); margin-top: 2svw; margin-bottom: 2svw; margin-left: 2svw; margin-right: 2svw; border-radius: 9px; display: flex; flex-flow: column">
                    <p
                        style="margin-top: 2svw; margin-left: 2svw; margin-right: auto; font-family: Goldman; font-size: 12px; font-weight: 300; color: #3F616C;">
                        Foto 1</p>
                    <img id="preview"
                        style="margin-top: 2svw; margin-left: 2svw; margin-right: 2svw; height: 90%; object-fit: cover;" />
                </v-card>
                <v-card elevation="12"
                    style="height: calc(100svh - 13.4svh - 2svw - 2svw - 2svw - 2svw - calc(100svh - 13.4svh - 2svw - 2svw - 2svw - 2svw - 22.66svh)); width: calc(100svw - 2svw - 2svw); margin-left: 2svw; margin-right: 2svw; border-radius: 9px; display: flex; align-items: center; flex-flow: row">
                    <v-btn elevation="12" v-on:click="click(true)"
                        style="margin-left: auto; margin-right: auto; width: 147px; height: 49px; border: 1px solid #E9F6FB;
                          font-family: Lato; text-transform: unset !important; font-style: normal; background-color: #FFFFFF; color: #059BCA; font-size: 16px; box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25); border-radius: 6px;">
                        <b>Enviar</b>
                    </v-btn>
                    <v-btn elevation="12" v-on:click="click(false)"
                        style="margin-left: auto; margin-right: auto; width: 147px; height: 49px; border: 1px solid #E9F6FB;
                          font-family: Lato; text-transform: unset !important; font-style: normal; background-color: #FFFFFF; color: #059BCA; font-size: 16px; box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25); border-radius: 6px;">
                        <b>Descartar</b>
                    </v-btn>
                </v-card>
            </v-row>
        </v-container>
    </v-main>
</template>

<script>
import CardNav from './CardNav.vue';
import { nextScreen } from '../router/utils.js';
import { preference } from "vue-preferences";

export default {
    name: 'PhotoUpload',
    components: {
        CardNav
    },
    methods: {
        click(accept) {
            if (accept) {
                nextScreen(this.$router, '/sendingphoto');
            } else {
                nextScreen(this.$router, '/lastdeposited');
            }
        }
    },
    mounted() {
        // TODO: add generic try catch to capture any possible error of this method
        const fileBase64UrlPref = preference('fileBase64Url', { defaultValue: '' });
        // Get the Object URL from the preferences
        const fileBase64Url = fileBase64UrlPref.get();
        const imagePreview = document.getElementById("preview");
        // The "src" field allows setting an Object URL directly, so it will display the image correctly
        imagePreview.src = fileBase64Url;
    }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/PhotoUpload.vue